export const MAIN_CONTENT_ID = "main-content";

export function getRouteAnnouncement(pathname: string): string {
  const cleanPath = pathname.split("?")[0]?.replace(/^\/+|\/+$/g, "") ?? "";
  if (!cleanPath) return "Home";

  const parts = cleanPath
    .split("/")
    .filter(Boolean)
    .filter((part) => !/^[a-z0-9]{8,}$/i.test(part));

  if (parts.length === 0) return "Home";

  return parts
    .map((part) => part.replace(/[-_]/g, " "))
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(", ");
}

export function getStepAnnouncement(step: number, total: number, label: string): string {
  return `Step ${step} of ${total}: ${label}`;
}

export function getValidationAnnouncement(message: string): string {
  return message.trim() ? `There is an issue to review. ${message}` : "There is an issue to review.";
}
